import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../CommonCssFiles/planstyle.css";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { changeDateFormat, getDate } from "../helper/common";
import "./HDFC.css";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, FormLabel } from "@mui/material";
import "./AllMed.css";
import "../commonComponents/HDFC.css";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import {
  selectProposal,
  updateHDFCQuestion,
  updateHDFCPersion,
  updateHDFCQAlist,
  selectHDFCcheckedQuestion,
  selectHDFCcheckedPersion,
} from "../redux/Slice";

const search = window.location.search;
const params = new URLSearchParams(search);
const unique_id = params.get("req_id");
const plan_id = params.get("plan_id");
const c_id = params.get("c_id");

export const HDFCQuestionAnswer = ({
  data,
  index,
  insuredData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  medErrors,
  setMedErrors,
}) => {
  const updateHDFCQuestion = ({ val }) => {
    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (updatedState.hasOwnProperty(val)) {
        delete updatedState[val];
      } else {
        updatedState[val] = {};
      }

      return updatedState;
    });
  };

  useEffect(() => {
    if (medErrors.length > 0) {
      const firstErrorElement = document.querySelector(
        `[data-question-id="${medErrors[0]}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [medErrors]);

  return (
    <>
      <div
        className="all-que-div col-md-12"
        data-question-id={data.question_id}
      >
        <div
          className={
            medErrors.includes(data.question_id)
              ? "col-md-12 pmd-all med-error-present"
              : "col-md-12 pmd-all med-error-absent"
          }
        >
          <FormControlLabel
            value={data.question_id}
            onChange={(e) => {
              const isChecked = e.target.checked;
              updateHDFCQuestion({ val: e.target.value });

              if (!isChecked) {
                setMedErrors((prevErrors) =>
                  prevErrors.filter((id) => id !== data.question_id)
                );
              }
            }}
            control={
              <Checkbox
                className={
                  medErrors.includes(data.question_id)
                    ? "checkbox-error"
                    : "checkbox-normal"
                }
              />
            }
            label={"Q. " + data.question}
            checked={HDFCcheckedQuestion.hasOwnProperty(data.question_id)}
            className={
              medErrors.includes(data.question_id)
                ? "label-error"
                : "label-normal"
            }
          />
        </div>
      </div>
    </>
  );
};
export const HDFCPersion = ({
  data,
  persion,
  pindex,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
}) => {
  const [selectedGender, setSelectedGender] = useState(
    localStorage.getItem("selectedType")
  );

  const updateHDFCPerson = (payload) => {
    const { question_id, pindex } = payload;
    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[question_id]) {
        updatedState[question_id] = {};
      }

      const question = updatedState[question_id];

      if (question.hasOwnProperty(pindex)) {
        delete question[pindex];
      } else {
        question[pindex] = [];
      }

      return updatedState;
    });
  };
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");

  const check = () => {
    if (HDFCcheckedQuestion.hasOwnProperty(data.question_id)) {
      if (HDFCcheckedQuestion[data.question_id].hasOwnProperty(pindex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    setSelectedGender(localStorage.getItem("selectedType"));
  }, []);

  const allowedRelationsByGender = {
    M: [
      "Mother",
      "Grand Mother",
      "Sister",
      "Wife",
      "Mother In Law",
      "Daughter",
    ],
    F: [
      "Mother",
      "Grand Mother",
      "Sister",
      "Wife",
      "Mother In Law",
      "Self",
      "Daughter",
    ],
  };

  const allowedRelations = allowedRelationsByGender[selectedGender] || [];

  let personPresent = allowedRelations.includes(persion?.InsuredRelation);

  return (
    <>
      <div
        className={`same-section-med col-md-6 ${
          data.question_id == 19 &&
          c_id == "hdfc" &&
          plan_id == "Family" &&
          !personPresent
            ? "hidden-section"
            : "visible-section"
        }`}
      >
        {/* <div
          hidden={!HDFCcheckedQuestion.hasOwnProperty(data.question_id)}
          onClick={() => {
            if( data.question_id == 19 &&
              c_id == "hdfc" &&
              plan_id == "Family" &&
              !personPresent){
                return
              }
              else{
                updateHDFCPerson({
                  pindex: pindex,
                  question_id: data.question_id,
                });
              }
        
          }}
          className="clickable-box"
        >
          <div
            className={`${
              check() ? "sumbox all-med-sum col-md-12" : "sumbox all-med-addon"
            } sumbox-center`}
          >
            <div>
              <span className={check() ? "para" : "para-unchecked"}>
                {proposerData?.InsuredDetail[pindex]?.InsuredName}
                <span className={check() ? "para-relation" : "para-rel"}>
                  ({persion?.InsuredRelation})
                </span>{" "}
              </span>
            </div>
          </div>
        </div> */}

        <div
          hidden={!HDFCcheckedQuestion.hasOwnProperty(data.question_id)}
          onClick={(e) => {
            if (
              data.question_id == 19 &&
              c_id == "hdfc" &&
              plan_id == "Family" &&
              !personPresent
            ) {
              // Prevent the click if condition is met
              e.stopPropagation();
              return;
            } else {
              updateHDFCPerson({
                pindex: pindex,
                question_id: data.question_id,
              });
            }
          }}
          className={`clickable-box ${
            data.question_id == 19 &&
            c_id == "hdfc" &&
            plan_id == "Family" &&
            !personPresent
              ? "disabled-box"
              : ""
          }`}
          style={{
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <div
            // className={`${
            //   check() ? "sumbox all-med-sum col-md-12" : "sumbox all-med-addon"
            // } sumbox-center`}

            className={
              data.question_id == 19 &&
              c_id == "hdfc" &&
              plan_id == "Family" &&
              !personPresent
                ? "sumbox disabled-box"
                : check()
                ? "sumbox all-med-sum col-md-12"
                : "sumbox all-med-addon"
            }
          >
            <div>
              <span className={check() ? "para" : "para-unchecked"}>
                {proposerData?.InsuredDetail[pindex]?.InsuredName}

                {data.question_id == 19 &&
                c_id == "hdfc" &&
                plan_id == "Family" &&
                !personPresent ? (
                  <span>({persion?.InsuredRelation})</span>
                ) : (
                  <span className={check() ? "para-relation" : "para-rel"}>
                    ({persion?.InsuredRelation})
                  </span>
                )}

                {data.question_id == 19 &&
                c_id == "hdfc" &&
                plan_id == "Family" &&
                !personPresent ? (
                  <span>(Not Applicable)</span>
                ) : (
                  ""
                )}
              </span>
            </div>
          </div>
        </div>

        {data?.get_child_question?.map((child_data) => {
          return (
            <SubQuestionAnswer
              key={child_data.question_id}
              data={child_data}
              parentData={data}
              pindex={pindex}
              proposerData={proposerData}
              HDFCcheckedQuestion={HDFCcheckedQuestion}
              setHDFCcheckedQuestion={setHDFCcheckedQuestion}
            />
          );
        })}
      </div>
    </>
  );
};
export const SubQuestionAnswer = ({
  data,
  pindex,
  parentData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
}) => {
  const proposalData = useSelector(selectProposal);

  const dispatch = useDispatch();

  const check = () => {
    if (HDFCcheckedQuestion.hasOwnProperty(parentData.question_id)) {
      if (HDFCcheckedQuestion[parentData.question_id].hasOwnProperty(pindex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const [first, setFirst] = useState([]);

  useEffect(() => {
    const keysToCheck = [6, 19];
    const filteredObjects = keysToCheck
      .filter((key) => HDFCcheckedQuestion.hasOwnProperty(key))
      .map((key) => HDFCcheckedQuestion[key])
      .flat();

    setFirst(filteredObjects);
  }, []);

  const getDeliveryDate = () => {
    if (first.length > 0) {
      return first[0];
    }
  };

  const datadate = getDeliveryDate();

  let deliveryDates = [];
  for (const key in datadate) {
    if (datadate.hasOwnProperty(key)) {
      const questions = datadate[key];

      questions.forEach((question) => {
        if (question.Options && question.Options.length > 0) {
          question.Options.forEach((option) => {
            if (option.DeliveryDate) {
              deliveryDates.push(option.DeliveryDate);
            }
          });
        }
      });
    }
  }

  function HDFCquestionExist(qa, qid) {
    for (let i = 0; i < qa.length; i++) {
      if (qa[i].QuestionId == qid) {
        return i;
        break;
      }
    }
    return false;
  }
  function HDFCgetAnswerSet(qdata, name, value, parentQid) {
    if (parentQid == "14") {
      return {
        OptionId: qdata.question_id,
        OptionText: qdata.question,
        ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
        ConsultationDate: name == "ConsultationDate" ? value : "",
        DiagnosisDate: name == "DiagnosisDate" ? value : "",
        CurrentStatus: name == "CurrentStatus" ? value : "",
        LineOfManagement: name == "LineOfManagement" ? value : "",
        TreatmentDetails: name == "TreatmentDetails" ? value : "",
      };
    } else if (parentQid == "15") {
      if (qdata.question_id == "69") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          SurgeryDate: name == "SurgeryDate" ? value : "",
          SurgeryDetails: name == "SurgeryDetails" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          CurrentStatus: name == "",
          DiagnosisDate: name == "",
          SurgeryDate: name == "",
          SurgeryDetails: name == "",
        };
      }
    } else if (parentQid == "16") {
      if (qdata.question_id == "71") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          ConsultationDate: name == "ConsultationDate" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          TreatmentDetails: name == "TreatmentDetails" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          DiagnosisDate: name == "",
          ConsultationDate: name == "",
          CurrentStatus: name == "",
          TreatmentDetails: name == "",
        };
      }
    } else if (parentQid == "17") {
      if (qdata.question_id == "73") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          TestFinding: name == "TestFinding" ? value : "",
          TestDate: name == "TestDate" ? value : "",
          TypeOfTest: name == "TypeOfTest" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          TestFinding: name == "",
          TestDate: name == "",
          TypeOfTest: name == "",
        };
      }
    } else if (parentQid == "18") {
      if (qdata.question_id == "75") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          ConsultationDate: name == "ConsultationDate" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          TreatmentDetails: name == "TreatmentDetails" ? value : "",
          LineOfManagement: name == "LineOfManagement" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          DiagnosisDate: name == "",
          ConsultationDate: name == "",
          CurrentStatus: name == "",
          TreatmentDetails: name == "",
          LineOfManagement: name == "",
        };
      }
    } else if (parentQid == "19") {
      if (qdata.question_id == "77") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          DeliveryDate: name == "DeliveryDate" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          DeliveryDate: name == "",
        };
      }
    } else if (
      ["87", "88", "89", "90", "91", "92", "93", "94"].includes(parentQid)
    ) {
      if (parentQid == "93") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Visual / Hearing  disability",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: qdata.question,
        };
      }
    }
  }

  const updateHDFCQAlist = (payload) => {
    const { parentqData, pindex, qdata, name, value } = payload;
    const parentQid = parentqData.question_id;

    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[parentQid]) {
        updatedState[parentQid] = {};
      }

      const question = updatedState[parentQid];

      if (!question[pindex]) {
        question[pindex] = [];
      }

      const qa = question[pindex];

      const newObj = {
        QuestionId: parentqData.question_id,
        QuestionText: parentqData.question,
        Options: [HDFCgetAnswerSet(qdata, name, value, parentQid)],
      };

      let questionKey = HDFCquestionExist(qa, parentQid);

      if (questionKey === false) {
        qa.push(newObj);
      } else {
        // const objKey = qa.findIndex((item) => item.QuestionId == parentQid);
        const options = qa[questionKey]["Options"];
        const optionIndex = options.findIndex(
          (item) => item.OptionId == qdata.question_id
        );

        if (optionIndex === -1) {
          options.push(HDFCgetAnswerSet(qdata, name, value, parentQid));
        } else {
          options[optionIndex][name] = value;
        }

        // **Dynamically filter out empty options**
        updatedState[parentQid][pindex] = qa
          .map((question) => ({
            ...question,
            Options: question.Options.filter((option) => {
              const keys = Object.keys(option).filter(
                (key) => key !== "OptionId" && key !== "OptionText"
              );
              return !keys.every((key) => option[key] === "");
            }),
          }))
          .filter((question) => question.Options.length > 0);
      }

      return updatedState;
    });
  };

  return (
    <>
      {!check() == false && data.question != "No" ? (
        <div
          className="ppv10 my-3 col-md-12"
          style={{
            flexWrap: "wrap",
            height: "auto",
            marginRight: "0px",
            minWidth: "248px",
            padding: "0px",
          }}
          hidden={
            ["87", "88", "89", "90", "91", "92", "93", "94"].includes(
              parentData.question_id
            )
              ? true
              : !check()
          }
        >
          <div
            className={
              parentData.question_id != "14"
                ? !["87", "88", "89", "90", "91", "92", "93", "94"].includes(
                    parentData.question_id
                  )
                  ? "col-md-12"
                  : "col-md-12 test-form-container addedClassHdfc"
                : "col-md-12 test-form-container"
            }
            style={{ marginRight: "7px" }}
          >
            <span
              className="nfh1 cash"
              style={{
                fontWeight: "600",
                display: data.question == "Yes" ? "none" : "block",
              }}
            >
              {data.question == "Yes"
                ? null
                : ["87", "88", "89", "90", "91", "92", "93", "94"].includes(
                    parentData.question_id
                  )
                ? `${data.question} added `
                : data.question}
            </span>
            {parentData.question_id == "14" ? (
              <AnswerSetOne
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "15" ? (
              <AnswerSetTwo
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "16" ? (
              <AnswerSetThree
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "17" ? (
              <AnswerSetFour
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "18" ? (
              <AnswerSetFive
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "19" ? (
              <AnswerSetSeven
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : ["87", "88", "89", "90", "91", "92", "93", "94"].includes(
                parentData.question_id
              ) ? (
              <AnswerSetSix
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : null}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export const AnswerSetOne = React.memo(
  ({
    pindex,
    qdata,
    parentqData,
    value,
    proposerData,
    HDFCcheckedQuestion,
    setHDFCcheckedQuestion,
    updateHDFCQAlist,
  }) => {
    const dispatch = useDispatch();

    const [dataObj, setDataObj] = useState();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      setTimeout(() => setVisible(true), 100);
    }, []);

    // useEffect(() => {
    //   if (HDFCcheckedQuestion) {
    //     // const keys = Object.keys(HDFCcheckedQuestion);
    //     // const numbersToCheck = 14;
    //     // const anyNumberPresent = numbersToCheck.some((number) =>
    //     //   keys.includes(number.toString())
    //     // );

    //     // const resultObjects = numbersToCheck
    //     //   .filter((number) => keys.includes(number.toString()))
    //     //   .map((number) => HDFCcheckedQuestion[number.toString()]);

    //     const resultObjects =HDFCcheckedQuestion[14];

    //     for (let key in resultObjects) {
    //       if (resultObjects[key].hasOwnProperty(pindex)) {
    //         let data_one = resultObjects[key][pindex];

    //         // let newobject = data_one.find(
    //         //   (item) => item.QuestionId == parentqData.question_id
    //         // );
    //         let newobject = data_one.QuestionId == parentqData.question_id ? data_one : undefined
    //         if (newobject != undefined) {
    //           // let newobject = val;

    //           // if (newobject) {
    //           for (let i = 0; i < newobject.Options.length; i++) {
    //             let item = newobject.Options[i];
    //             if (item.OptionId == qdata.question_id) {
    //               setDataObj(item);
    //               return;
    //             }

    //           }
    //           //   newobject.Options.forEach((item) => {
    //           //     if (item.OptionId == qdata.question_id) {
    //           //       setDataObj(item);
    //           //       return;
    //           //     }
    //           //   }
    //           // );
    //           // }
    //         }
    //       }
    //     }
    //   }
    // }, [HDFCcheckedQuestion]);

    useEffect(() => {
      if (HDFCcheckedQuestion) {
        const keys = Object.keys(HDFCcheckedQuestion);
        const numbersToCheck = [14];
        const anyNumberPresent = numbersToCheck.some((number) =>
          keys.includes(number.toString())
        );
        const resultObjects = numbersToCheck
          .filter((number) => keys.includes(number.toString()))
          .map((number) => HDFCcheckedQuestion[number.toString()]);
        let val;
        for (let key in resultObjects) {
          if (resultObjects[key].hasOwnProperty(pindex)) {
            let data_one = resultObjects[key][pindex];
            let val = data_one.find(
              (item) => item.QuestionId == parentqData.question_id
            );
            if (val != undefined) {
              let newobject = val;
              if (newobject) {
                newobject.Options.map((item, index) => {
                  if (item.OptionId == qdata.question_id) {
                    setDataObj(item);
                    return;
                  }
                });
              }
            }
          }
        }
      }
    }, []);

    const normalizeDate = (dateString) => {
      if (dateString) {
        const [year, month, day] = dateString.split("-");
        const paddedMonth = month.padStart(2, "0");
        const paddedDay = day.padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
      }
    };

    return (
      <>
        <Box
          className={`medical-test-form que-one-family ${
            visible ? "show" : ""
          }`}
          key={JSON.stringify(dataObj || {})}
        >
          {/* {console.log("the dataobj in set one ", dataObj)} */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          // value: getDate(e),
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.DiagnosisDate))
                      : null
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj.DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parsing
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Last Consultation Date
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.ConsultationDate
                      ? dayjs(normalizeDate(dataObj?.ConsultationDate))
                      : null
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.ConsultationDate
                      ? dayjs(normalizeDate(dataObj.ConsultationDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parsing
                        }

                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Details of Treatment given
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={
                  dataObj?.TreatmentDetails ? dataObj?.TreatmentDetails : ""
                }
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Line of Management
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={
                  dataObj?.LineOfManagement ? dataObj?.LineOfManagement : ""
                }
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "LineOfManagement",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              >
                <option value="" disabled>
                  Select Line of Management
                </option>
                <option value="Medical Management">Medical Management</option>
                <option value="Surgical Management">Surgical Management</option>
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  }
);
export const AnswerSetTwo = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [15];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj.Options[0].DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parse
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Surgery
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "SurgeryDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.SurgeryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.SurgeryDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.SurgeryDate
                      ? dayjs(normalizeDate(dataObj.Options[0].SurgeryDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "SurgeryDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parse
                        }

                        updateHDFCQAlist({
                          name: "SurgeryDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Details of your past surgery
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.SurgeryDetails || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "SurgeryDetails",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetThree = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [16];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj.Options[0].DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parse
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Last Consultation Date
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                        )
                      : ""
                  }
                />
              </LocalizationProvider> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj.Options[0].ConsultationDate)
                        )
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parse
                        }

                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Treatment Details
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.TreatmentDetails || ""}
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetFour = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [17];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <Box
      className={`medical-test-form ${visible ? "show" : ""}`}
      key={JSON.stringify(dataObj?.Options[0] || {})}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" className="medical-label">
            Test Finding
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            name="testFinding"
            size="small"
            placeholder="Enter test finding"
            className="medical-input"
            defaultValue={dataObj?.Options[0]?.TestFinding || ""}
            onBlur={(e) =>
              updateHDFCQAlist({
                name: "TestFinding",
                value: e.target.value,
                pindex,
                qdata,
                parentqData,
              })
            }
          />
        </Grid>
        <Grid item xs={12}>
          {/* <Typography variant="body2" className="medical-label">
        Test Date
      </Typography> */}
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              className: "medical-input",
            },
          }}
          format="DD/MM/YYYY"
          defaultValue={
            dataObj?.Options[0]?.TestDate
              ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
              : null
          }
          onChange={(date) =>
            updateHDFCQAlist({
              name: "TestDate",
              value: date ? date.format("YYYY-MM-DD") : "",
              pindex,
              qdata,
              parentqData,
            })
          }
        />
      </LocalizationProvider> */}
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Test Date
            </Typography>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      updateHDFCQAlist({
                        name: "TestDate",
                        value: e.target.value
                          ? dayjs(e.target.value, "DD/MM/YYYY").format(
                              "YYYY-MM-DD"
                            )
                          : "",
                        pindex,
                        qdata,
                        parentqData,
                      });
                    },
                  },
                }}
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options[0]?.TestDate
                    ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
                    : null
                }
              />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options?.[0]?.TestDate
                    ? dayjs(normalizeDate(dataObj.Options[0].TestDate))
                    : null
                }
                onAccept={(newValue) => {
                  updateHDFCQAlist({
                    name: "TestDate",
                    value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                    pindex,
                    qdata,
                    parentqData,
                  });
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      const raw = e.target.value;
                      let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(raw); // fallback
                      }

                      updateHDFCQAlist({
                        name: "TestDate",
                        value: parsedDate.isValid()
                          ? parsedDate.format("YYYY-MM-DD")
                          : "",
                        pindex,
                        qdata,
                        parentqData,
                      });
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" className="medical-label">
            Type of Test
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            name="typeOfTest"
            size="small"
            placeholder="Enter type of test"
            className="medical-input"
            defaultValue={dataObj?.Options[0]?.TypeOfTest || ""}
            onBlur={(e) =>
              updateHDFCQAlist({
                name: "TypeOfTest",
                value: e.target.value,
                pindex,
                qdata,
                parentqData,
              })
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export const AnswerSetFive = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [18];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease or Injury Details
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Details"
                className="medical-input"
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj.Options[0].DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback for loose formats
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Consultation Date
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                        )
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options?.[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj.Options[0].ConsultationDate)
                        )
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;
                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);

                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback to flexible parsing
                        }

                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Treatment Details
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.TreatmentDetails || ""}
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Line of Management
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={
                  dataObj?.Options[0]?.LineOfManagement
                    ? dataObj?.Options[0]?.LineOfManagement
                    : ""
                }
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "LineOfManagement",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              >
                <option value="" disabled>
                  Select Line of Management
                </option>
                <option value="Medical Management">Medical Management</option>
                <option value="Surgical Management">Surgical Management</option>
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetSeven = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [19];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        <Box className={`medical-test-form ${visible ? "show" : ""}`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Delivery Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      readOnly: true,
                    },
                  }}
                  minDate={dayjs()}
                  format="DD/MM/YYYY"
                  value={
                    dataObj?.Options[0]?.DeliveryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DeliveryDate))
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "DeliveryDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetEight = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [19];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  return (
    <>
      <Checkbox
        defaultChecked={
          dataObj?.Options[0] &&
          dataObj?.Options[0].OptionId == qdata.question_id
            ? true
            : false
        }
        inputProps={{ "aria-label": "controlled" }}
        onBlur={(e) => {
          updateHDFCQAlist({
            name: "data",
            value: e.target.checked,
            pindex: pindex,
            qdata: qdata,
            parentqData: parentqData,
          });
        }}
      />
    </>
  );
};
export const AnswerSetSix = ({
  pindex,
  qdata,
  parentqData,
  deliverydate,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [87, 88, 89, 90, 91, 92, 93, 94];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (
      ["87", "88", "89", "90", "91", "92", "93", "94"].includes(
        parentqData.question_id
      )
    ) {
      updateHDFCQAlist({
        name: "data",
        value: true,
        pindex: pindex,
        qdata: qdata,
        parentqData: parentqData,
      });
    }
  }, []);

  return (
    <>
      <Checkbox
        checked={dataObj?.Options[0] ? true : false}
        inputProps={{ "aria-label": "controlled" }}
      />
    </>
  );
};
